import React, { useRef, useState } from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { data } from "../../../LocalData/db";
import { bgandheaderColorMultipleForScrollItem } from "../../../support/multipleclr";

const Agile = () => {
  const [dataList, setDataList] = useState(data);
  const [isHovering, setIsHovering] = useState(false);
  const [scrollDirection, setScrollDirection] = useState<
    "left" | "right" | null
  >(null);
  const containerRef = useRef<HTMLDivElement>(null);

  const handleMouseOver = () => {
    setIsHovering(true);
    setScrollDirection(null);
  };

  const handleMouseOut = () => {
    setIsHovering(false);
  };

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (isHovering && containerRef.current) {
      if (e.clientX > containerRef.current.scrollLeft) {
        setScrollDirection("right");
      } else if (e.clientX < containerRef.current.scrollLeft) {
        setScrollDirection("left");
      }
      containerRef.current.scrollLeft = e.clientX;
    }
  };

  return (
    <section id="agile" style={{ backgroundColor: "#FBFBFE" }}>
      <Container maxWidth="lg" sx={{ padding: "160px 0 30px" }}>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container>
            <Grid item xs={12} md={12}>
              <Typography
                variant="h3"
                gutterBottom
                sx={{ textAlign: { xs: "center", sm: "center", md: "left" } }}
              >
                World-class agile product teams to{" "}
                <span className="highlight-head">scale your business</span>
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Container>
      <Box
        sx={{
          overflowX: "scroll",
          display: "grid",
          gridAutoColumns: "375px",
          gridColumnGap: "10px",
          gridAutoFlow: "column",
          padding: "25px 0px",
          scrollSnapType: "x mandatory",
          marginBottom: { xs: "44px", sm: "44px", md: "120px" },
          paddingBottom: { xs: "69px", sm: "69px", md: "87px" },
        }}
        ref={containerRef}
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
        onMouseMove={handleMouseMove}
        className="scrollbar"
        id="style-scrollbar"
      >
        {dataList.map((item, i) => (
          <Card
            sx={{
              display: "flex",
              top: i % 2 === 0 ? "24px" : 0,
              position: "relative",
              alignItems: "center",
              padding: "30px 18px 22px",
              border: " 1px solid rgb(252, 217, 195)",
              boxShadow:
                "rgba(0, 0, 0, 0.06) 0px 1px 18px 0px, rgba(0, 0, 0, 0.1) 0px 3px 5px -1px",
              transition: "all 800ms cubic-bezier(0.2, 0.8, 0.2, 1) 0s",
              borderRadius: 0,
              "&:hover": {
                boxShadow:
                  "rgba(0, 0, 0, 0.1) 0px 11px 15px -3px, rgba(0, 0, 0, 0.04) 0px 9px 30px 3px, rgba(0, 0, 0, 0.04) 0px 20px 30px 3px",
                transform: "translateY(-5px)",
                backgroundColor: bgandheaderColorMultipleForScrollItem(i),
                "& .serviceHeader": {
                  transform: "translateY(-7px)",
                  color: "rgb(239, 83, 102)",
                },
                "& .serviceDesc": { transform: "translateY(-4px)" },
                "& .serviceIcon": {
                  transform: "translateY(-11px)",
                  boxShadow: "rgba(0, 0, 0, 0.1) 0px 20px 40px",
                },
              },
            }}
          >
            <CardMedia
              component="img"
              className="serviceIcon"
              sx={{
                width: 51,
                height: 51,
                transition: "all 800ms cubic-bezier(0.2, 0.8, 0.2, 1) 0s",
              }}
              image={item.img}
              alt="Live from space album cover"
            />
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <CardContent sx={{ flex: "1 0 auto" }}>
                <Typography
                  component="div"
                  variant="h5"
                  className="serviceHeader"
                  sx={{
                    color: "rgb(61, 61, 61)",
                    transition: "all 800ms cubic-bezier(0.2, 0.8, 0.2, 1) 0s",
                    marginBottom: 0,
                  }}
                >
                  {item.title}
                </Typography>
                <Typography
                  variant="subtitle1"
                  color="text.secondary"
                  className="serviceDesc"
                  component="div"
                  sx={{
                    marginBottom: 0,
                    transition: "all 800ms cubic-bezier(0.2, 0.8, 0.2, 1) 0s",
                  }}
                >
                  {item.description}
                </Typography>
              </CardContent>
            </Box>
          </Card>
        ))}
      </Box>
    </section>
  );
};

export default Agile;
